module.exports = __webpack_public_path__ + "static/media/ic-close.3ba1d4c0.svg";